import React from "react";

export default function ItemHeader(props) {
    return(
        <a href={props.route}  className="font-bold self-center justify-self-center" ><button className="text-texto-400 md:text-base text-sm hover:text-desinfopedia duration-200">{props.texto}</button></a>
    );
}